import styled from 'styled-components';

import { commonMaxWidth, flexColumn, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS, FONT_SIZE } from 'styles/style-constants';

export const Main = styled.div`
    width: 100%;
    ${commonMaxWidth};
    padding: 4rem 4rem 9.6rem;
    display: grid;
    grid-template-columns: minmax(0, 100rem) 36.6rem;
    justify-content: space-between;
    align-items: start;
    column-gap: 3.2rem;

    ${respondDown(Breakpoints.md)`
        display: block;
        padding: 2.4rem 1.6rem 6.4rem;
    `}
`;

export const MainColumn = styled.div`
    ${flexColumn};
    gap: 3.2rem;
    min-width: 0;
`;

export const Header = styled.div`
    ${flexColumn};
    gap: 2.4rem;
`;

export const AssetInfoSection = styled.section`
    padding: 3.2rem;
    background: ${COLORS.surface};
    border-radius: 3.2rem;

    ${respondDown(Breakpoints.md)`
        padding: 2.4rem;
        border-radius: 2.4rem;
    `}
`;

export const Content = styled.div`
    ${flexColumn};
    gap: 3.2rem;
`;

export const SectionCard = styled.section`
    padding: 3.2rem;
    background: ${COLORS.surface};
    border-radius: 3.2rem;

    ${respondDown(Breakpoints.md)`
        padding: 2.4rem;
        border-radius: 2.4rem;
    `}
`;

export const SectionTitle = styled.h2`
    ${FONT_SIZE.lg};
    color: ${COLORS.textPrimary};
    margin-bottom: 2.4rem;
`;

export const SidebarColumn = styled.aside`
    position: sticky;
    top: 4rem;
    align-self: start;
    margin-top: 7.2rem;

    ${respondDown(Breakpoints.md)`
        display: none;
    `}
`;
